import React, { useEffect, useState } from 'react';

function App() {
  const [message, setMessage] = useState('Hello');
  const [pressCount, setPressCount] = useState(0);
  const [grayscale, setGrayscale] = useState(false);
  const [jumping, setJumping] = useState(false);
  const letters = message.split('');

  const toggleGreeting = () => {
    setMessage((currentMessage) => (currentMessage === 'Hello' ? 'Goodbye' : 'Hello'));
    setPressCount((c) => {
      const next = c + 1;
      if (next % 10 === 0) setGrayscale((prev) => !prev);
      return next;
    });
  };

  useEffect(() => {
    const triggerJump = () => {
      if (jumping) return;

      setJumping(true);
      window.setTimeout(() => setJumping(false), 500);
    };

    const handleGlobalKeyDown = (event) => {
      if (event.key === ' ' || event.key === 'Spacebar' || event.code === 'Space') {
        event.preventDefault();
        triggerJump();
      }

      if (event.key === 'Enter') {
        event.preventDefault();
        toggleGreeting();
      }
    };

    window.addEventListener('keydown', handleGlobalKeyDown);
    return () => window.removeEventListener('keydown', handleGlobalKeyDown);
  }, [jumping]);

  return (
    <div className={`app-shell${grayscale ? ' grayscale' : ''}`}>
      <div
        className={`welcome-card${jumping ? ' jumping' : ''}`}
        aria-label={`welcome screen, ${pressCount} presses`}
      >
        <h1
          className="welcome-title"
          onClick={toggleGreeting}
          onMouseDown={(event) => event.preventDefault()}
          role="button"
          tabIndex={0}
        >
          {letters.map((letter, index) => (
            <span
              key={`${letter}-${index}`}
              className="wave-letter"
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              {letter}
            </span>
          ))}
        </h1>
      </div>
    </div>
  );
}

export default App;
